const DEFAULT_PAGE_LIMIT = 100

export async function asyncFetchData(url) {
  try {
    const response = await fetch(url);
    return response.json();
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function asyncPaginatedFetch(url, pageLimit = DEFAULT_PAGE_LIMIT, page = 1, previousResponse = []) {
  return fetch(`${url}&page=${page}&limit=${pageLimit}`) // Append the page number to the base URL
    .then(response => response.json())
    .then(newResponse => {
      const results = [...previousResponse, ...newResponse]; // Combine the two arrays
      if (newResponse.length === pageLimit) {
        page += 1;
        return asyncPaginatedFetch(url, pageLimit, page, results);
      }

      return results;
    })
    .catch(err => {
      console.error(err)
      return []
    })
}
